var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuit24 = function SvgSuit24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1 6a5.002 5.002 0 0 1 9.8 0h.1a5 5 0 0 1 3 9v2a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5v-2a5 5 0 0 1 3-9h.1Zm2.07 0a3.001 3.001 0 0 1 5.66 0H9.17ZM20 11a3 3 0 0 1-3 3h-2a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2H7a3 3 0 1 1 0-6h10a3 3 0 0 1 3 3ZM6 16v1a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-1H6Z",
    fill: "currentColor"
  })));
};
export default SvgSuit24;